import component from "./LoginForm";

export default component;
